<template>
  <div class="hello">



    <!--                <p>correct: {{ challenge.steps[challenge.currentStep].correctFrames.length }} incorrect:-->
    <!--                    {{ challenge.steps[challenge.currentStep].incorrectFrames.length }}</p>-->
    <div class="webcam_capture" ref="webcam_capture" :style="heightStyle">
      <!--            <img :src="animation_src" alt="" class="animation">-->
      <img :src="arrow_animation_src" alt="" class="arrow-animation"
           :class="arrow_animation_src.includes('left')? 'place-left': 'place-right'">
      <p class="video-message" :class="{'text-highlight':highlightText}"><b>{{ instruction }}</b></p>
      <canvas ref="canvasOutput" class="center-block" id="canvasOutput" :style="heightStyle"></canvas>
      <p class="text-highlight font" style="position: relative; top: 35%; width: 100%; z-index: 15">
        <b>{{ distanceInstruction }}</b>
      </p>
      <video @canplay="canplayVideoHandler" ref="video" id="video" class="hidden" :style="heightStyle">
        Your browser does not support
        the video tag.
      </video>
      <div style="position: absolute;top: 50%;left: 44%" class="text-center" v-if="!streaming">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>

        </div>
        <p>Loading</p>
      </div>

    </div>


    <!-- </overlay> -->
    <div class="invisible">
      <!--            <video @canplay="canplayVideoHandler" ref="video" id="video" class="hidden" :style="heightStyle">-->
      <!--                Your browser does not support-->
      <!--                the video tag.-->
      <!--            </video>-->
    </div>

  </div>
</template>

<script>
var ops = require("ndarray-ops")
import * as centerFace from "../assets/3D_Face_Center.gif";
import * as leftFace from "../assets/3D_Face_Left.gif";
import * as rightFace from "../assets/3D_Face_Right.gif";
import * as rightArrow from "../assets/rightArrow.gif";
import * as leftArrow from "../assets/leftArrow.gif";

export default {
  name: "WebcamCaptureOpenCV_Face",
  props: {
    msg: String,
    screen_type: String
  },
  data() {
    return {
      landmarks:{},
      insideBox: false,
      predictions: [],
      highlightText: false,
      temp: 0,
      bell: null,
      actions: ['left', 'right'],
      challenge: {
        currentStep: 0,
        completed: false,
        steps: []
      },
      errCount: 0,
      faceProb: 0,
      streaming: false,
      videoWidth: {},
      videoHeight: {},
      video: {},
      webcam_capture: {},
      heightStyle: {
        height: "300px !important"
      },
      canvasOutput: {},
      canvasOutputCtx: {},
      stream: null,
      faceClassifier: null,
      src: null,
      dstC1: null,
      dstC2: null,
      dstC3: null,
      dstC4: null,
      lookLeftRight: "",
      canvasInput: null,
      canvasInputCtx: null,
      canvasBuffer: null,
      canvasBufferCtx: null,
      canvasFace: null,
      canvasFaceCtx: null,
      srcMat: {},
      grayMat: {},
      capturedImage: "",
      capturedImageBlob: {},
      detections: 0,
      mediaRecorder: {},
      recordedChunks: [],
      recordVideoUrl: {},
      recordVideo: {},
      orientation: "",
      look: "",
      faceDistance: "",
      distance: {
        left: 0,
        right: 0,
        leftMinusRight: 0,
        rightMinusLeft: 0,
        eyes: 0
      },
    };
  },
  computed: {
    distanceInstruction: function () {
      if (this.faceDistance === "far") {
        return "Move Closer"
      }
      if (this.faceDistance === "near") {
        return "Move Back"
      }
      return ""
    },
    instruction: function () {

      if (this.predictions.length > 1) {
        return "works on one face only"
      }

      if (this.challenge.currentStep >= this.challenge.steps.length) {
        return this.$t("faceVerified")
      }
      if (this.challenge.steps.length <= 0) {
        return ""
      }
      if (this.challenge.steps[this.challenge.currentStep].action === 'straight') {
        return this.$t("centerFaceAlignMsg")
      }
      if (this.challenge.steps[this.challenge.currentStep].action === 'left') {
        return this.$t("leftFaceAlignMsg")
      }
      if (this.challenge.steps[this.challenge.currentStep].action === 'right') {
        return this.$t("rightFaceAlignMsg")
      }
      return ""
    },
    animation_src: function () {
      if (this.challenge.steps.length <= 0) {
        return ""
      }
      if (this.challenge.steps[this.challenge.currentStep].action === 'straight') {
        return centerFace
      }
      if (this.challenge.completed === true) {
        return ""
      }
      if (this.challenge.steps[this.challenge.currentStep].action === 'left') {
        return leftFace;
      }
      if (this.challenge.steps[this.challenge.currentStep].action === 'right') {
        return rightFace
      }

      return ""
    },
    arrow_animation_src() {
      if (this.challenge.steps.length <= 0) {
        return ""
      }
      if (this.challenge.completed === true) {
        return ""
      }
      if (this.challenge.currentStep >= this.challenge.steps.length) {
        return ""
      }
      if (this.challenge.steps[this.challenge.currentStep].action !== 'straight' && this.challenge.steps[this.challenge.currentStep]) {
        if (this.challenge.steps[this.challenge.currentStep].action === 'left') {
          return leftArrow;
        }
        if (this.challenge.steps[this.challenge.currentStep].action === 'right') {
          return rightArrow
        }
      }
      return ""
    }
  },
  watch: {
    instruction: function (val) {
      this.highlightText = true;
      setTimeout(() => {
        this.highlightText = false;
      }, 3000)
    },
  },
  mounted() {
    this.resetChallenge('reset')
    this.video = this.$refs.video;
    this.webcam_capture = this.$refs.webcam_capture;
    this.canvasOutput = this.$refs.canvasOutput;
    this.canvasOutputCtx = this.canvasOutput.getContext("2d");
    this.bell = new Audio("bell.mp3");

    this.startCamera();
    this.$once("hook:beforeDestroy", function () {
      this.endExecution();
    });
  },
  methods: {
    showError(message) {
      const options = {
        title: message,
        text: this.$t("retryQuestion"),
        icon: 'question',
        showCancelButton: false,

        confirmButtonText: this.$t("yesRetry"),
        cancelButtonText: this.$t("no"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary btn-md ripple-parent",
          cancelButton: "btn  btn-md ripple-parent"
        },
        buttonsStyling: false,
      };

      this.$swal.fire(options).then(res => {
        if (res.value) {
          window.location.reload();
          // eslint-disable-next-line no-undef
        }
      })

    },
    endExecution() {
      // this.streaming = false;
      this.stopVideoProcessing();
      this.stream.getTracks().forEach(function (track) {
        track.stop();
      });
    },

    startCamera: function () {
      if (this.streaming) return;

      navigator.mediaDevices
          .getUserMedia({video: {facingMode: 'user'}, audio: false})
          .then(s => {
            this.stream = s;
            this.video.srcObject = s;
            this.video.play();
            const options = {mimeType: "video/webm", videoBitsPerSecond: 1250000};
            this.mediaRecorder = new MediaRecorder(s, options);

            this.mediaRecorder.addEventListener("start", () => {
              console.log("data started");
            });
            this.mediaRecorder.addEventListener("dataavailable", e => {
              console.log("data available");
              if (e.data.size > 0) {
                this.recordedChunks.push(e.data);
              }
            });

            this.mediaRecorder.addEventListener("stop", () => {
              // this.playVideo()
              this.recordVideo = new Blob(this.recordedChunks);
              const blob = new Blob(this.recordedChunks, {
                type: 'video/webm'
              });
              this.processRecordedVideo(blob);
              this.uploadRecordingVideo();
              // var url = URL.createObjectURL(blob);
              // var a = document.createElement('a');
              // document.body.appendChild(a);
              // a.style = 'display: none';
              // a.href = url;
              // a.download = 'test.webm';
              // a.click();
              // window.URL.revokeObjectURL(url);
            });

            this.mediaRecorder.start();
          })
          .catch(function (err) {
            this.showError(err.message)
          });
    },
    canplayVideoHandler: function () {
      if (!this.streaming) {
        this.videoWidth = this.video.videoWidth;
        this.videoHeight = this.video.videoHeight;
        this.video.setAttribute("width", this.videoWidth);
        this.video.setAttribute("height", this.videoHeight);
        // this.webcam_capture.setAttribute("height", this.videoHeight);
        // this.webcam_capture.style.height = "1000px !important";
        let newHeight = (this.videoHeight / this.videoWidth) * this.video.clientWidth;
        this.heightStyle = {
          height: newHeight + "px !important"
        }
        this.$forceUpdate();


        this.canvasOutput.width = this.videoWidth;
        this.canvasOutput.height = this.videoHeight;
        this.streaming = true;
      }
      this.startVideoProcessing();
    },
    startVideoProcessing: function () {
      if (!this.streaming) {
        console.warn("Please startup your webcam");
        return;
      }
      this.stopVideoProcessing();
      this.canvasInput = document.createElement("canvas");
      this.canvasInput.width = this.videoWidth;
      this.canvasInput.height = this.videoHeight;
      this.canvasInputCtx = this.canvasInput.getContext("2d");

      this.canvasBuffer = document.createElement("canvas");
      this.canvasBuffer.width = this.videoWidth;
      this.canvasBuffer.height = this.videoHeight;
      this.canvasBufferCtx = this.canvasBuffer.getContext("2d");


      this.canvasFace = document.createElement("canvas");
      this.canvasFace.width = this.videoWidth;
      this.canvasFace.height = this.videoHeight;
      this.canvasFaceCtx = this.canvasFace.getContext("2d");


      requestAnimationFrame(this.processVideo);
    },
    stopVideoProcessing: function () {
      if (this.src != null && !this.src.isDeleted()) this.src.delete();
      if (this.dstC1 != null && !this.dstC1.isDeleted()) this.dstC1.delete();
      if (this.dstC3 != null && !this.dstC3.isDeleted()) this.dstC3.delete();
      if (this.dstC4 != null && !this.dstC4.isDeleted()) this.dstC4.delete();
    },
    processRecordedVideo(blob) {
      try {
        this.recordVideo = blob;
      } catch (e) {
        if (this.errCount > 5) {
          alert(e);
        } else {
          this.errCount += 1
          this.processRecordedVideo();
        }
      }
    },
    uploadRecordingVideo() {
      let formData = new FormData();
      formData.append("video", this.recordVideo, `${this.$store.state.session_id}_face_video`);
      formData.append("session", this.$store.state.session_id);
      this.$http.post("/upload-face-video", formData).then(res => {
      }).catch(err => {
        this.handleError(err)
      });
    },
    processVideo: function () {
      console.log("process video")
      if (!this.streaming) {
        // dont execute the function if streaming has ended
        return;
      }

      if (this.challenge.completed === true) {
        //end the function if hundred detections done


        this.canvasOutputCtx.drawImage(this.canvasFace, 0, 0, this.videoWidth, this.videoHeight);
        this.endExecution();
        this.capturedImage = this.canvasOutput.toDataURL();

        let imageDataUrl = this.canvasFace.toDataURL("image/jpeg");

        this.canvasFace.toBlob(blob => {
          this.capturedImageBlob = blob;
          this.$emit("captureComplete", imageDataUrl, this.recordVideo);
        });
        return;
      }


      let t3 = new Date();
      //

      // copy image to another canvas
      this.canvasInputCtx.scale(-1, 1);
      this.canvasInputCtx.drawImage(this.video, this.videoWidth * -1, 0, this.videoWidth, this.videoHeight);
      const flipHorizontal = false;

      let t1 = new Date();

      this.$blazeface.estimateFaces(this.canvasInput, false, flipHorizontal).then((async predictions => {

        let t2 = new Date();
        this.canvasOutputCtx.clearRect(0, 0, this.canvasOutput.width, this.canvasOutput.height);

        let ellipseBox = {
          x: this.videoWidth / 2 - this.videoWidth / 3,
          y: this.videoHeight / 2 - this.videoHeight / 3,
          w: this.videoWidth * 2 / 3,
          h: this.videoHeight * 2 / 3,
          cx: this.videoWidth / 2,
          cy: this.videoHeight / 2,
          area: (this.videoWidth * 2 / 3) * (this.videoHeight * 2 / 3)
        }
        let distThreshold = 100

        this.canvasOutputCtx.lineWidth = 3;
        this.canvasOutputCtx.globalAlpha = 0.6


        this.canvasOutputCtx.beginPath();
        this.canvasOutputCtx.ellipse(ellipseBox.cx, ellipseBox.cy, ellipseBox.w / 2, ellipseBox.h / 2, 0, 0, 2 * Math.PI);
        this.canvasOutputCtx.rect(this.videoWidth, 0, -this.videoWidth, this.videoHeight);
        this.canvasOutputCtx.fill();

        this.canvasOutputCtx.globalAlpha = 1

        if (this.challenge.currentStep > 0) {
          this.canvasOutputCtx.lineWidth = 10;
          this.canvasOutputCtx.strokeStyle = "#00ff00";
        } else {
          this.canvasOutputCtx.lineWidth = 5;
          this.canvasOutputCtx.strokeStyle = "white";
        }


        this.canvasOutputCtx.beginPath();
        this.canvasOutputCtx.ellipse(this.videoWidth / 2, this.videoHeight / 2, this.videoWidth / 3, this.videoHeight / 3, 0, 0, 2 * Math.PI);
        this.canvasOutputCtx.stroke();

        this.canvasOutputCtx.lineWidth = 3;

        this.predictions = predictions;

        if (predictions.length === 1 && predictions[0].probability > 0.8) {
          this.faceProb = predictions[0].probability;

          const start = predictions[0].topLeft;
          const end = predictions[0].bottomRight;
          const size = [end[0] - start[0], end[1] - start[1]];
          const area = size[0] * size[1];
          const midpoint = [(start[0] + end[0]) / 2, (start[1] + end[1]) / 2];
          const landmarks = predictions[0].landmarks;
          this.landmarks = landmarks

          this.canvasOutputCtx.strokeStyle = "red";
          this.canvasOutputCtx.strokeRect(start[0], start[1], size[0], size[1]);
          this.canvasOutputCtx.strokeStyle = "white";


          let distance_between_left_lines = Math.abs(start[0] - ellipseBox.x)
          let distance_between_right_lines = Math.abs(end[0] - (ellipseBox.x + ellipseBox.w))

          let leftLine_right_of_ellipse = start[0] >= ellipseBox.x - (ellipseBox.w*0.1)
          let rightLine_left_of_ellipse = end[0] <= (ellipseBox.x + ellipseBox.w + (ellipseBox.w*0.1))
          let top_below_ellipse = start[1] >= ellipseBox.y - (ellipseBox.h*0.1);
          let bottom_above_ellipse = end[1] <= (ellipseBox.y + ellipseBox.h + (ellipseBox.h*0.1));
          this.insideBox = (leftLine_right_of_ellipse && rightLine_left_of_ellipse && top_below_ellipse && bottom_above_ellipse)

          this.faceDistance = this.face_distance(landmarks);
          this.look = this.looking(landmarks)[0];

          if (this.faceDistance === "normal" && this.insideBox === true) {

            if (this.challenge.completed !== true) {
              if (this.challenge.steps[this.challenge.currentStep].action === this.look) {
                this.challenge.steps[this.challenge.currentStep].correctFrames.push({});
              } else if (this.look !== "straight") {
                this.challenge.steps[this.challenge.currentStep].incorrectFrames.push({});
              }
              let currentStep = this.challenge.steps[this.challenge.currentStep];

              if (currentStep.incorrectFrames.length > 2) {
                this.resetChallenge("reset");
              }
              if (currentStep.correctFrames.length > 3) {

                this.canvasFaceCtx.drawImage(this.canvasInput, 0, 0, this.videoWidth, this.videoHeight);
                if (currentStep.action === "straight") {

                  let image = this.canvasFace.toDataURL("image/jpeg");
                  let formData = new FormData();
                  formData.append("image", image)
                  if (this.$store.state.session_id !== null) {
                    formData.append("session", this.$store.state.session_id)
                  } else {
                    const urlSearchParams = new URLSearchParams(window.location.search);
                    const params = Object.fromEntries(urlSearchParams.entries());
                    formData.append('meta', params.meta)
                  }
                  try {
                    let url;
                    if (this.screen_type === "face_liveness") {
                      url = "/upload-face-frame"
                    } else if (this.screen_type === "agent_verification") {
                      url = "/upload-agent-frame"
                    }
                    let response = await this.$http.post(url, formData)
                    // this.$http.post("/upload-face-frame",formData).then(response=>{
                    this.$store.commit("setSessionID", {session_id: response.data.session})
                    this.bell.play();
                    navigator.vibrate(500)
                    this.challenge.steps[this.challenge.currentStep + 1].action = response.data.challenge
                    this.challenge.currentStep = this.challenge.currentStep + 1
                  } catch (err) {

                    if (err.response.status === 400) {
                      if ('non_field_errors' in err.response && err.response.non_field_errors.length > 0) {
                        this.showError(err.response.non_field_errors[0])
                      } else if ('data' in err.response) {
                        if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length > 0) {
                          this.showError(err.response.data.non_field_errors[0])
                        } else {
                          if (Array.isArray(err.response.data) && err.response.data.length > 0) {
                            this.showError(JSON.stringify(err.response.data[0]))
                          } else {
                            this.showError(JSON.stringify(err.response.data))
                          }
                        }
                      } else {
                        this.showError(JSON.stringify(err.response))
                      }
                    } else if (err.response && err.response.status === 401) {
                      this.$router.push('/expired')
                    } else {
                      this.showError(err.response)
                    }
                  }
                  // })
                } else {
                  this.challenge.currentStep = this.challenge.currentStep + 1
                }


                if (this.challenge.currentStep >= this.challenge.steps.length) {
                  // this.resetChallenge("complete");
                  this.challenge.completed = true;
                }
              }
            }

          } else {
            this.resetChallenge("reset")
          }


        } else {
          this.resetChallenge()
          this.faceDistance = ""
          this.look = ""
          this.insideBox = false
        }

        let t4 = new Date();
        console.log("total time:", t4 - t3)
        requestAnimationFrame(this.processVideo)

      }))


    },
    drawResults: function (ctx, results, color, size) {
      for (let i = 0; i < results.length; ++i) {
        let rect = results[i];
        let xRatio = this.videoWidth / size.width;
        let yRatio = this.videoHeight / size.height;
        ctx.lineWidth = 3;
        ctx.strokeStyle = color;
        ctx.strokeRect(
            rect.x * xRatio,
            rect.y * yRatio,
            rect.width * xRatio,
            rect.height * yRatio
        );
      }
    },
    drawLine: function (ctx, p1, p2) {
      ctx.beginPath();
      ctx.lineWidth = 3;
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
    },
    calculateOrientationOfLine(p1, p2) {
      if (Math.abs(p2.x - p1.x) < 50) {
        return "vertical";
      } else if (Math.abs(p2.y - p1.y) < 50) {
        return "horizontal";
      }

    },
    distanceBetweenTwoPoints(p1, p2) {
      return Math.sqrt(Math.pow((p2.x - p1.x), 2) + Math.pow(p2.y - p1.y, 2))
    },
    is_tilted(landmarks, thresh = 15) {
      let r_eye = landmarks[1]
      let l_eye = landmarks[0]
      let nose = landmarks[2]
      let mouth = landmarks[3]
      let r_ear = landmarks[4]
      let l_ear = landmarks[5]

      let eyes_angle = Math.atan((l_eye[1] - r_eye[1]) / (l_eye[0] - r_eye[0])) * 180 / Math.PI
      if (Math.abs(eyes_angle) > thresh) {
        return true
      }
    },

    face_distance(landmarks) {
      let r_eye = landmarks[1]
      let l_eye = landmarks[0]


      let dist = Math.sqrt((r_eye[0] - l_eye[0]) ** 2 + (r_eye[1] - l_eye[1]) ** 2)
      let prox = ""


      if (dist<50){
        prox = "far"
      }
      else if (dist>=50 && dist<=120){
        prox = "normal"
      }
      else {
        prox = "near"
      }
      return prox

    },
    looking(landmarks, x_thresh = 0.25) {
      let x_look = "straight"
      let y_look = "straight"

      let r_eye = landmarks[1]
      let l_eye = landmarks[0]
      let nose = landmarks[2]
      let mouth = landmarks[3]
      let r_ear = landmarks[4]
      let l_ear = landmarks[5]

      if (!this.is_tilted(landmarks,25)) {
        if (nose[0] <= l_eye[0]) {
          // x_look = "TOO LEFT!"
          x_look = "left"
        } else if (nose[0] >= r_eye[0]) {
          // x_look = "TOO RIGHT!"
          x_look = "right"
        }

        if (x_look === "straight") {
          let eye_dist = Math.abs(r_eye[0] - l_eye[0])
          let nose_l_eye = Math.abs(nose[0] - l_eye[0])
          if ((nose_l_eye / eye_dist) < x_thresh) {
            x_look = "left"
          } else if ((nose_l_eye / eye_dist) > (1 - x_thresh)) {
            x_look = "right"
          }
        }

        if (nose[1] < l_ear[1] && nose[1] < r_ear[1]) {
          y_look = "up"
        } else if (l_ear[1] < l_eye[1] && r_ear[1] < r_eye[1]) {
          y_look = "down"
        }

        return [x_look, y_look]
      } else {
        return ["HEAD IS TILTED!", "HEAD IS TILTED!"]
      }
    },
    resetChallenge(msg) {
      this.challenge = {
        currentStep: 0,
        completed: false,
        steps: [
          {
            action: 'straight',
            correctFrames: [],
            incorrectFrames: [],
            incorrectFramesCountWhenSomeCorrectFramesCaptured: 0
          },
          {
            action: this.actions[Math.floor(Math.random() * this.actions.length)],
            correctFrames: [],
            incorrectFrames: [],
            incorrectFramesCountWhenSomeCorrectFramesCaptured: 0
          }
        ]
      }
    }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
canvas {
  border: 1px solid rgba(0, 0, 0, 0.3);
  /*background-clip: padding-box;*/
}

.animation {
  width: 20% !important;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;

}

.arrow-animation {
  width: 15% !important;
  position: absolute;
  top: 45%;
  z-index: 15;

}

.place-left {
  left: 0;
}

.place-right {
  right: 0;
}

.invisible {
  display: none;
}

.webcam_capture {
  /*height: 480px;*/
  width: 130% !important;

  /*background-clip: content-box;*/
  /*padding-top: 70%;*/
  position: relative;
  margin-left: -15%;


}

canvas {
  /*height: 480px;*/
  width: 100% !important;
  /*background-color: black;*/
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  /*bottom: 0;*/
  /*right: 0;*/
  /*-webkit-transform: scaleX(-1);*/
  /*transform: scaleX(-1);*/
}

#video {
  /*height: 480px;*/
  width: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
  /*display: none;*/
}

video {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.text-red {
  color: red;
}
</style>
